import React from 'react';

import { filter } from 'lodash';

import DebouncedField from 'components/DebouncedField';
import SearchFilter from 'components/SearchFilter';

const DebouncedSearchFilter = (props) => (
  <DebouncedField {...props} component={DebouncedSearchFilterComponent} />
);

const DebouncedSearchFilterComponent = ({
  onChange,
  SearchFilterComponent = SearchFilter,
  ...props
}) => (
  <SearchFilterComponent
    filterOptions={(options) =>
      filter(options, (opt) =>
        opt.toLowerCase().includes(props.value.toLowerCase())
      )
    }
    onInputChange={(e, newValue) => {
      if (props.value !== newValue) {
        onChange({ target: { value: newValue } });
      }
    }}
    {...props}
  />
);

export default DebouncedSearchFilter;
